// src/pages/Home.jsx
export default function Home() {
    return <h1>Главная страница</h1>;
}